module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00000-fs8.f8676b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00000-fs8.png
// module id = 154
// module chunks = 0